{
  "helloWorld": "Hello, World!",
  "clickMe": "Click me",
  "healthCheckFailed": "Health check failed",
  "errors": {
    "unexpected": "An unexpected error occurred"
  },
  "error": {
    "title": "Something went wrong",
    "description": "An unexpected error occurred. You can try again or go back home.",
    "tryAgain": "Try again",
    "goHome": "Go home"
  },
  "dev": {
    "errorPreview": "Error Preview"
  },
  "actions": {
    "label": "Actions",
    "edit": "Edit",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "expand": "Expand",
    "collapse": "Collapse"
  },
  "validation": {
    "tooLong": "Must be {{max}} characters or fewer",
    "tooShort": "Required",
    "invalidFormat": "Invalid format",
    "invalid": "Invalid value"
  },
  "nav": {
    "workspace": "Workspace",
    "controlCenter": "Control Center",
    "jobs": "Jobs",
    "analytics": "Analytics",
    "company": "Company",
    "agentCommunications": "Agent Communications",
    "integrations": "Integrations",
    "suggestedCandidates": "Suggested Candidates",
    "unsolicitedApplications": "Unsolicited Applications",
    "team": "Team",
    "templates": "Templates",
    "workflow": "Workflow",
    "settings": "Settings",
    "language": "Language",
    "help": "Help",
    "logout": "Log out",
    "administration": "Administration",
    "adminTenant": "Tenant Settings",
    "adminOrganizations": "Organizations",
    "adminDepartments": "Departments",
    "openMenu": "Open menu"
  },
  "admin": {
    "tenants": {
      "title": "Tenants",
      "newTenant": "New tenant",
      "columns": {
        "name": "Name",
        "createdAt": "Created at",
        "actions": "Actions"
      },
      "createDialog": {
        "title": "Create tenant",
        "namePlaceholder": "Acme Corp"
      },
      "editDialog": {
        "title": "Edit tenant"
      }
    },
    "tenant": {
      "title": "Tenant Settings",
      "name": "Tenant Name",
      "save": "Save changes",
      "saved": "Saved"
    },
    "organizations": {
      "title": "Organizations",
      "newOrg": "New organization",
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "tenant": "Tenant",
        "createdAt": "Created at",
        "actions": "Actions"
      },
      "createDialog": {
        "title": "Create organization",
        "namePlaceholder": "Acme Corp",
        "slugPlaceholder": "acme-corp",
        "newTenant": "New tenant",
        "existingTenant": "Existing tenant",
        "tenantName": "Tenant name",
        "tenantNamePlaceholder": "Acme Corp",
        "selectTenant": "Select tenant"
      },
      "editDialog": {
        "title": "Edit organization",
        "language": "Language",
        "languagePlaceholder": "Select language"
      },
      "deleteConfirm": {
        "title": "Delete organization",
        "description": "This will also delete all departments in this organization. This action cannot be undone.",
        "confirm": "Delete",
        "cancel": "Cancel"
      }
    },
    "departments": {
      "title": "Departments",
      "newDept": "New department",
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "createdAt": "Created at",
        "actions": "Actions"
      },
      "createDialog": {
        "title": "Create department",
        "namePlaceholder": "Engineering",
        "slugPlaceholder": "engineering"
      },
      "editDialog": {
        "title": "Edit department"
      },
      "deleteConfirm": {
        "title": "Delete department",
        "description": "This action cannot be undone.",
        "confirm": "Delete",
        "cancel": "Cancel"
      }
    }
  },
  "team": {
    "title": "Team",
    "invite": "Invite colleagues",
    "search": "Search for name, email, department...",
    "department": "Department",
    "roles": {
      "admin": "Admin",
      "org_manager": "Org Manager",
      "dept_manager": "Department Manager",
      "user": "User"
    },
    "columns": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "actions": "Actions"
    },
    "inviteDialog": {
      "title": "Invite colleague",
      "email": "Email address",
      "role": "Role",
      "departments": "Departments",
      "submit": "Send invitation"
    },
    "actions": {
      "changeRole": "Change role",
      "addDepartment": "Add to department",
      "removeDepartment": "Remove from department",
      "removeFromOrg": "Remove from organization"
    },
    "noResults": "No results found.",
    "noMembers": "No team members yet."
  },
  "jobs": {
    "title": "Jobs",
    "backToJobs": "Jobs",
    "newJob": "New job",
    "createNewJob": "Create new job",
    "importFromAts": "Import from {{atsName}}",
    "searchPlaceholder": "Search jobs...",
    "completedPlaceholder": "{{completed}} of {{total}} completed",
    "tabs": {
      "active": "Active",
      "archived": "Archived"
    },
    "columns": {
      "name": "Name",
      "createdBy": "Created by",
      "createdAt": "Created at",
      "actions": "Actions"
    },
    "empty": "No jobs found.",
    "emptyTitle": "No jobs yet",
    "emptyDescription": "Create your first job or import from your ATS to get started.",
    "emptySearchDescription": "No jobs match your search.",
    "createError": "Failed to create job. Please try again.",
    "status": {
      "active": "Active",
      "archived": "Archived"
    },
    "setupStatus": {
      "draft": "Draft",
      "questions_pending": "Setup needed",
      "ready": "Ready",
      "active": "Active"
    },
    "applicantSync": {
      "syncingBanner": "Fetching candidates from {{provider}}...",
      "failedBanner": "Candidate sync failed",
      "adminActions": "Admin actions",
      "resyncLabel": "Sync applicants now",
      "lastSyncedAt": "Last synced at: {{date}}",
      "addDemoApplicant": "Add demo applicant"
    },
    "detail": {
      "tabs": {
        "candidates": "Candidates",
        "results": "Results",
        "settings": "Settings"
      },
      "info": {
        "title": "Job Information",
        "employer": "Employer",
        "location": "Location",
        "description": "Description",
        "modality": "Interview Modality",
        "languages": "Languages",
        "atsProvider": "ATS Provider",
        "atsId": "ATS Job ID",
        "noDescription": "No description provided."
      },
      "questions": {
        "title": "Interview Questions",
        "empty": "No questions configured for this job.",
        "optional": "Optional",
        "categories": {
          "eligibility": "Eligibility",
          "job_expectations": "Job Expectations",
          "assessment": "Assessment",
          "information": "Information"
        }
      }
    }
  },
  "wizard": {
    "step": "Step {{current}} of {{total}}",
    "back": "Back",
    "next": "Continue",
    "goLive": "Go live",
    "saveAndContinue": "Save & continue",
    "manual": {
      "title": "New job",
      "step1Title": "Basic info",
      "step2Title": "Interview questions",
      "step3Title": "Confirm & go live"
    },
    "import": {
      "title": "Import from ATS",
      "step0Title": "Select jobs",
      "step1Title": "Map stages",
      "step2Title": "Interview settings",
      "step3Title": "Interview questions",
      "step4Title": "Confirm & go live"
    },
    "stageSelector": {
      "title": "Map pipeline stages",
      "description": "Select which stage in each job maps to each Kiku action. Pre-filled where stage names matched your defaults.",
      "continue": "Continue",
      "loading": "Loading stages…"
    },
    "basicInfo": {
      "title": "Job title",
      "titlePlaceholder": "e.g. Senior Software Engineer",
      "description": "Job description",
      "descriptionPlaceholder": "Describe the role, responsibilities, and requirements...",
      "descriptionHint": "Used by AI to generate relevant interview questions",
      "employer": "Employer name (optional)",
      "employerPlaceholder": "e.g. Acme Corp",
      "modality": "Interview format",
      "modalityText": "Text chat",
      "modalityTextDesc": "Candidate types responses in a chat interface",
      "modalityVoice": "Voice interview",
      "modalityVoiceDesc": "Live audio interview held in a virtual meeting room",
      "languages": "Interview language(s)",
      "languagesHint": "Select at least one language",
      "languagesSearch": "Search languages…",
      "languagesEmpty": "No language found.",
      "modalityRequired": "Select at least one interview format",
      "languagesRequired": "Select at least one language"
    },
    "atsSelector": {
      "title": "Select jobs to import",
      "search": "Search jobs...",
      "selectAll": "Select all",
      "selected": "{{count}} selected",
      "noJobs": "No active jobs found in your ATS",
      "noDescription": "No description available — AI will generate from title only",
      "continue": "Continue with {{count}} job(s)"
    },
    "sharedSettings": {
      "title": "Interview settings",
      "subtitle": "These settings will apply to all imported jobs"
    },
    "questions": {
      "title": "Interview questions",
      "generateError": "Failed to generate questions. Please try again.",
      "retry": "Retry",
      "generating": "Generating questions with AI...",
      "generatingHint": "This usually takes 5–10 seconds",
      "addQuestion": "Add question",
      "categories": {
        "eligibility": "Eligibility",
        "job_expectations": "Job Expectations",
        "assessment": "Assessment",
        "information": "Information Gathering"
      },
      "categoryDescriptions": {
        "eligibility": "Yes/no questions about hard requirements",
        "job_expectations": "Day-in-the-life and role preview",
        "assessment": "Behavioural and competency questions",
        "information": "Open-ended gathering questions"
      },
      "optional": "Optional",
      "competency": "Competency",
      "scoringExamples": "Scoring examples",
      "score1": "Score 1 — Poor",
      "score3": "Score 3 — Adequate",
      "score5": "Score 5 — Excellent",
      "aiGenerated": "AI-generated"
    },
    "confirm": {
      "title": "Ready to go live",
      "jobsCount": "{{count}} job(s) will be activated",
      "questionsCount": "{{count}} interview question(s)",
      "modality": "Format",
      "languages": "Languages",
      "goLiveHint": "Candidates will be able to start interviews immediately after activation."
    }
  },
  "login": {
    "title": "Sign in to Kiku",
    "subtitle": "Manage your recruiting pipeline.",
    "cta": "Sign in",
    "waitingForLogin": "Waiting for login…",
    "disclosure": "You are interacting with an AI system. Kiku uses AI to assist with recruiting — all decisions are subject to human review.",
    "errors": {
      "not_provisioned": "Your account isn't set up yet. Contact your administrator.",
      "missing_code": "Authentication failed. Please try again.",
      "session_expired": "Your session has expired. Please sign in again."
    }
  },
  "settings": {
    "profile": {
      "title": "Profile",
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "departments": "Departments"
    }
  },
  "integrations": {
    "title": "Integrations",
    "ats": {
      "title": "ATS Connection",
      "description": "Connect your Applicant Tracking System to sync jobs and manage candidate stages.",
      "provider": "Provider",
      "apiKey": "API Key",
      "apiKeyPlaceholder": "Enter your API key",
      "apiKeySet": "Key saved — enter a new value to replace it",
      "save": "Save connection",
      "verify": "Verify connection",
      "verifyStatus": {
        "valid": "Connected",
        "invalid": "Invalid key",
        "error": "Verification failed",
        "idle": "Not verified",
        "loading": "Verifying..."
      },
      "providers": {
        "teamtailor": "Teamtailor",
        "recman": "RecMan"
      }
    },
    "stageMapping": {
      "title": "Stage Mapping",
      "description": "Map your ATS stages to Kiku workflow stages.",
      "initialStage": "Initial stage",
      "passInterviewStage": "Pass interview",
      "failInterviewStage": "Fail interview",
      "recommendedStage": "Recommended",
      "selectStage": "Select a stage",
      "save": "Save mapping"
    },
    "errors": {
      "notConfigured": "No ATS configured. Save your connection first.",
      "fetchStagesFailed": "Could not load stages from your ATS.",
      "saveFailed": "Failed to save configuration."
    }
  },
  "applications": {
    "title": "Applications",
    "newCandidate": "New candidate",
    "addCandidate": "Add new candidate",
    "emptyStage": "No applications",
    "emptyTitle": "No candidates yet",
    "emptyDescription": "Add your first candidate to start reviewing applications.",
    "emptySearchDescription": "No candidates match your search.",
    "searchPlaceholder": "Search by name, email or phone",
    "createDialog": {
      "title": "Add application",
      "name": "Full name",
      "namePlaceholder": "e.g. Jane Doe",
      "email": "Email address",
      "emailPlaceholder": "e.g. jane@example.com",
      "phoneNumber": "Phone number",
      "phoneNumberPlaceholder": "e.g. 555-1234",
      "phoneCountryCode": "Country code",
      "phoneCountryCodePlaceholder": "e.g. +1",
      "submit": "Create application"
    },
    "errors": {
      "conflict": "This candidate already has an application for this job."
    },
    "detail": {
      "title": "Application details",
      "stage": "Stage",
      "interviewLink": "Interview link",
      "interviewStatus": "Interview status",
      "copyLink": "Copy link",
      "linkCopied": "Copied!",
      "noInterview": "No interview session found",
      "openInterview": "Open interview",
      "commChannel": {
        "label": "Send via",
        "manual": "Manual",
        "email": "Email",
        "sms": "SMS",
        "whatsapp": "WhatsApp"
      },
      "status": {
        "pending": "Pending",
        "in_progress": "In Progress",
        "completed": "Completed",
        "expired": "Expired"
      }
    }
  },
  "pagination": {
    "rowsPerPage": "Rows per page",
    "rowsSelected": "{{count}} of {{total}} row(s) selected.",
    "pageOf": "Page {{page}} of {{total}}"
  },
  "screening": {
    "title": "Screening Interview",
    "aiDisclosure": "You are chatting with Sara, an AI recruitment assistant",
    "selectLanguage": "Select your preferred language",
    "selectLanguageDescription": "The interview will be conducted in the language you choose",
    "startInterview": "Start interview",
    "typeMessage": "Type your message...",
    "send": "Send",
    "typing": "Sara is typing...",
    "submitInterview": "Submit interview",
    "loading": "Loading interview...",
    "completed": {
      "title": "Interview completed",
      "message": "Thank you for completing the interview for {{jobTitle}}. A recruiter will review your responses and be in touch."
    },
    "expired": {
      "title": "Interview expired",
      "message": "This interview link has expired. Please contact the recruiter for a new invitation."
    },
    "notFound": {
      "title": "Interview not found",
      "message": "This interview link is not valid. Please check the link and try again."
    },
    "error": {
      "title": "Something went wrong",
      "message": "An error occurred. Please try again later.",
      "sendFailed": "Failed to send message. Please try again."
    },
    "languages": {
      "en": "English",
      "es": "Spanish",
      "fr": "French",
      "de": "German",
      "pt": "Portuguese",
      "it": "Italian",
      "nl": "Dutch",
      "sv": "Swedish",
      "no": "Norwegian",
      "da": "Danish",
      "fi": "Finnish",
      "pl": "Polish",
      "ar": "Arabic",
      "zh": "Chinese",
      "ja": "Japanese",
      "ko": "Korean"
    }
  },
  "scoring": {
    "title": "Interview Results",
    "pending": "Scoring in progress...",
    "processing": "AI is evaluating the interview...",
    "failed": "Scoring failed",
    "overallScore": "Overall Score",
    "overallScoreTooltip": "Score from 0–100 based on the average of all assessment question scores, adjusted for eligibility and job expectations.",
    "recommendation": "Recommendation",
    "recommendations": {
      "shortlist": "Recommended",
      "reject": "Not Recommended",
      "review": "Needs Review"
    },
    "summary": "Summary",
    "eligibility": "Eligibility",
    "expectations": "Job Expectations",
    "assessment": "Assessment",
    "transcript": "Interview Transcript",
    "copyPasteDetected": "Copy-pasted answer",
    "copyPasteWarning": "Copy-paste detected in this interview",
    "copyPasteWarningTooltip": "One or more candidate answers were pasted during the interview. This may indicate the candidate used pre-written responses.",
    "verdicts": {
      "pass": "Pass",
      "fail": "Fail",
      "unsure": "Unsure",
      "review": "Needs Review"
    },
    "optional": "Optional",
    "averageScore": "Average question score",
    "reasoning": "Reasoning",
    "evidence": "Evidence",
    "backToJob": "Back to job"
  },
  "workflows": {
    "title": "Workflow",
    "description": "Configure the stages that applications move through during your hiring process.",
    "stages": {
      "title": "Pipeline stages",
      "subtitle": "Drag to reorder. Applications progress through these stages from top to bottom.",
      "system": "System",
      "manage": "Manage stages",
      "addStage": "Add stage",
      "editStage": "Edit stage",
      "deleteStage": "Delete stage",
      "stageName": "Stage name",
      "stageColor": "Color",
      "deleteConfirm": "Delete this stage? Applications in this stage must be moved first.",
      "systemProtected": "System stages cannot be deleted",
      "hasApplications": "This stage still has applications assigned to it"
    }
  },
  "communications": {
    "title": "Agent Communications",
    "languageSelector": "Language",
    "tabs": {
      "sms": "SMS",
      "email": "Email"
    },
    "emailSubject": "Subject",
    "emailBody": "Body",
    "variables": {
      "candidateName": "Applicant Name",
      "jobTitle": "Job Title",
      "companyName": "Job Employer",
      "interviewLink": "Invite URL"
    },
    "actions": {
      "edit": "Edit",
      "save": "Save changes",
      "reset": "Reset to default",
      "saved": "Template saved",
      "resetDone": "Reverted to default"
    },
    "nodes": {
      "interviewIntro": "Interview intro",
      "interviewOutro": "Interview outro",
      "reminderToFinish": "Reminder to finish",
      "voiceAndChat": "Voice & Chat",
      "emailsAndSms": "Emails & SMS",
      "comingSoon": "Coming soon"
    },
    "characters": "{{count}}/{{max}} Characters",
    "smsSegments": "{{count}} SMS messages ({{size}} chars/segment)",
    "smsUnicodeWarning": "This message contains emojis or special characters that require Unicode encoding, reducing the limit to 67 characters per SMS.",
    "invite": {
      "title": "Candidate Invitation",
      "description": "Candidates receive this when added to a job listing. The email automatically includes a link to the interview.",
      "email": {
        "subject": "Interview invitation for {{jobTitle}} at {{companyName}}",
        "body": "<p>Hi {{candidateName}},</p><p>You have been invited to interview for the {{jobTitle}} position at {{companyName}}.</p><p><strong>Important:</strong> This interview is conducted by an AI system. You will be interacting with artificial intelligence, not a human interviewer.</p><p>Start your interview here: <a href=\"{{interviewLink}}\">{{interviewLink}}</a></p><p>Good luck!<br>{{companyName}}</p>"
      },
      "sms": "Hi {{candidateName}}, you're invited to interview for {{jobTitle}} at {{companyName}}. This interview uses AI. Start here: {{interviewLink}}"
    },
    "reminder": {
      "title": "Interview Reminder",
      "description": "Sent automatically if a candidate hasn't started their interview within 24 hours of receiving the invitation.",
      "email": {
        "subject": "Reminder: Complete your interview for {{jobTitle}} at {{companyName}}",
        "body": "<p>Hi {{candidateName}},</p><p>This is a friendly reminder to complete your interview for the {{jobTitle}} position at {{companyName}}.</p><p><strong>Important:</strong> This interview is conducted by an AI system. You will be interacting with artificial intelligence, not a human interviewer.</p><p>Continue your interview here: <a href=\"{{interviewLink}}\">{{interviewLink}}</a></p><p>Best regards,<br>{{companyName}}</p>"
      },
      "sms": "Hi {{candidateName}}, reminder to complete your {{jobTitle}} interview at {{companyName}}. AI interview. Continue: {{interviewLink}}"
    },
    "emailBodyPlaceholder": "Write your email..."
  },
  "activity": {
    "title": "Activity",
    "stageChange": "Moved from {{from}} to {{to}}",
    "interviewCompleted": "Completed screening interview",
    "scoreReceived": "Score received: {{score}}/100",
    "applicationCreated": "Application created",
    "noteAdded": "Note added",
    "bySystem": "System",
    "byAi": "AI",
    "empty": "No activity yet"
  },
  "atsPush": {
    "title": "ATS Push Status",
    "retry": "Retry ATS Push",
    "retrying": "Retrying...",
    "rerunStep": "Re-run this step",
    "rerunConfirm": "This step already completed successfully. Re-running it may create duplicate data in your ATS. Continue?",
    "steps": {
      "transcript": "Transcript",
      "stage_move": "Stage Move"
    },
    "status": {
      "completed": "Sent",
      "failed": "Failed",
      "pending": "Pending"
    },
    "note": {
      "title": "AI Screening Interview",
      "recommendation": "Recommendation",
      "score": "Score",
      "summary": "Summary",
      "eligibility": "Eligibility",
      "assessment": "Assessment",
      "transcript": "Transcript",
      "candidate": "Candidate",
      "interviewer": "Interviewer",
      "pass": "Pass",
      "fail": "Fail",
      "review": "Review",
      "shortlist": "Shortlist",
      "reject": "Reject",
      "viewProfile": "View candidate profile in Kiku",
      "transcriptAndAssessment": "TRANSCRIPT AND ASSESSMENT",
      "intro": "Intro",
      "eligibilityQuestions": "Eligibility questions",
      "jobExpectations": "Job expectations",
      "assessmentQuestions": "Assessment questions",
      "outro": "Outro",
      "assessmentExplanation": "ASSESSMENT EXPLANATION",
      "unsure": "Unsure",
      "viewInKiku": "VIEW IN KIKU FOR MORE DETAILS",
      "viewProfileLink": "View candidate profile in Kiku to see explanations for scores"
    }
  },
  "topbar": {
    "whatsNew": "What's new",
    "help": "Help",
    "notifications": "Notifications"
  },
  "extension_candidate_banner": {
    "description": "View candidate details.",
    "description_with_transcript": "View screening transcript & candidate details.",
    "open_in_kiku": "Open",
    "dismiss": "Dismiss"
  },
  "languages": {
    "en": "English",
    "es": "Spanish",
    "fr": "French",
    "de": "German",
    "pt": "Portuguese",
    "it": "Italian",
    "nl": "Dutch",
    "sv": "Swedish",
    "no": "Norwegian",
    "da": "Danish",
    "fi": "Finnish",
    "pl": "Polish",
    "ar": "Arabic",
    "zh": "Chinese",
    "ja": "Japanese",
    "ko": "Korean"
  },
  "environmentBanner": {
    "development": "Development",
    "test": "Test"
  },
  "notFound": {
    "title": "Page not found",
    "description": "The page you're looking for doesn't exist or has been moved.",
    "goHome": "Return to Kiku"
  },
  "results": {
    "exportLabel": "Export",
    "exportCsv": "Export CSV",
    "emptyTitle": "No results yet",
    "emptyDescription": "Completed interviews will appear here.",
    "columns": {
      "candidate": "Candidate",
      "stage": "Stage",
      "status": "Status",
      "score": "Score",
      "recommendation": "Recommendation",
      "eligibility": "Eligibility",
      "expectations": "Expectations",
      "avgScore": "Avg Score",
      "interviewDate": "Interview Date",
      "question": "Question"
    },
    "statusLabels": {
      "pending": "Pending",
      "processing": "Processing",
      "completed": "Completed",
      "failed": "Failed",
      "no_interview": "No interview"
    },
    "questionSections": {
      "eligibility": "Eligibility",
      "job_expectations": "Expectations",
      "assessment": "Assessment",
      "information": "Information"
    },
    "fields": {
      "reasoning": "Reasoning",
      "evidence": "Evidence",
      "response": "Response",
      "avgScoreLabel": "Avg Score",
      "interviewDate": "Interview Date"
    }
  }
}
